import { CONFIG } from '../../config/index';
import { getPermissionKey } from '../../helper/permissions';
let headers = {
    'X-Auth-Token': sessionStorage.getItem('token'),
    'Content-Type': 'multipart/form-data'
}
export const digivendStore = [
    {
        title: "getRetailerShipmentRetryData",
        actionPrefix: 'getRetailerShipmentRetry',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/document/edit/restrict`
        }
    },
    {
        title: "getSystemConfigKeysData",
        actionPrefix: 'getSystemConfigKeys',
        message: 'Config Keys Stored Successfully!',
        errorMessage: "Unable To Get the Digivend Config Keys!",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.SYSTEM_CONFIG}/get/active/key`,
            extraHeader: getPermissionKey("common", "commonFunctionality", "view"),
        }
    },
    {
        title: "EnterpriseGetPoDetailsremQtyData",
        actionPrefix: 'EnterpriseGetPoDetailsremQty',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/entpo/get/po/rem/qty`
        }
    },
    {
        title: "EnterpriseGetPoDetailsremQtyUpdateData",
        actionPrefix: 'EnterpriseGetPoDetailsremQtyUpdate',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/entpo/update`
        }
    },
    {
        title: "EnterpriseCancelPoData",
        actionPrefix: 'EnterpriseCancelPo',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.userType;
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/${payload.userType ? payload?.userType : "entpo"}/update`
        }
    },
    {
        title: "EnterpriseHoldAsnData",
        actionPrefix: 'EnterpriseHoldAsn',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/${payload?.userType}/update/asn/hold/status`
        }
    },
    {
        title: "extendPOValidityData",
        actionPrefix: 'extendPOValidity',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.PO}/extend/validity`
        }
    },
    {
        title: "bulkOperationData",
        actionPrefix: 'bulkOperation',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.PO}/bulk/operation`
        }
    },
    {
        title: "approvePOConfirmData",
        actionPrefix: 'approvePOConfirm',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorpo/confirm`
        }
    },
    {
        title: "enterpriseApprovedPoData",
        actionPrefix: 'enterpriseApprovedPo',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                return payload
            },
            buildUrl: (payload) => `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl}`
        }
    },
    {
        title: "shipmentConfirmCancelData",
        actionPrefix: 'shipmentConfirmCancel',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/entship/update/sr`
        }
    },
    {
        title: "getComqcInvoiceData",
        actionPrefix: 'getComqcInvoice',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.uniqueKey;
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/find/all/comqcinvoice`,
        }
    },
    {
        title: "uploadUtilityDocumentData",
        actionPrefix: 'uploadUtilityDocument',
        message: 'Image/File uploaded successfully!',
        errorMessage : `Failed to upload Image/File!`,
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/utility/document/upload`,
            extraHeader: {
                "Content-Type": "multipart/form-data",
            },
        }
    },
    {
        title: "getCompleteDetailShipmentData",
        actionPrefix: 'getCompleteDetailShipment',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/entship/find/srDetail`
        }
    },
    {
        title: "addMultipleCommentQcData",
        actionPrefix: 'addMultipleCommentQc',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/add/multiple/comqcinvoice`
        }
    },
    {
        title: "updateExtensionDateData",
        actionPrefix: 'updateExtensionDate',
        message: 'Request Completed Successfully',
        requestData: {
            // updatePayload: ({ ...payload }) => {
            //     return { shipmentUpdate: payload }
            // },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/update/date`
        }
    },
    {
        title: "updateVendorCancelLrData",
        actionPrefix: 'updateVendorCancelLr',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorlogi/lr/cancel`
        }
    },
    {
        title: "getAllVendorEntryDetailsData",
        actionPrefix: 'getAllVendorEntryDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/entlogi/get/gate/entry/details`
        }
    },
    {
        title: "indentBasePoV2Data",
        actionPrefix: 'indentBasePoV2',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/${decodeURIComponent(payload?.apiUrl)}`
        }
    },
    {
        title: "approveApptData",
        actionPrefix: 'approveAppt',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/entship/apt/approval`
        }
    },
    {
        title: "updateGateEntryCancelData",
        actionPrefix: 'updateGateEntryCancel',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorlogi/gateentry/cancel`
        }
    },
    {
        title: "getArsCancelData",
        actionPrefix: 'getArsCancel',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorlogi/partial/asn/cancel`
        }
    },
    {
        title: "getSystemConfigDataData",
        actionPrefix: 'getSystemConfigData',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.SYSTEM_CONFIG}/get/data`
        }
    },
    {
        title: "addWHApptSiteData",
        actionPrefix: 'addWHApptSite',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.SYSTEM_CONFIG}/add/appointment/wh/sites`
        }
    },
    {
        title: "addWHApptThresholdData",
        actionPrefix: 'addWHApptThreshold',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/create/threshold/config`
        }
    },
    {
        title: "getWHApptSiteDetailsData",
        actionPrefix: 'getWHApptSiteDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/get/site/details`
        }
    },
    {
        title: "addWHApptSiteDetailsData",
        actionPrefix: 'addWHApptSiteDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/create/appointment/site/details`
        }
    },

    {
        title: "getWHApptThresholdData",
        actionPrefix: 'getWHApptThreshold',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/get/threshold/config`
        }
    },
    {
        title: "deleteWHApptThresholdData",
        actionPrefix: 'deleteWHApptThreshold',
        message: 'Request Completed Successfully',
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/delete/threshold/${payload}`
        }
    },
    {
        title: "getPoMrpRangeData",
        actionPrefix: 'getPoMrpRange',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/admin/po/get/mrp/range`
        }
    },
    {
        title: "getVendorInvoiceData",
        actionPrefix: 'getVendorInvoice',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/get/invoice/details`
        }
    },
    {
        title: "updateInvoiceData",
        actionPrefix: 'updateInvoice',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/update/invoice`
        }
    },
    {
        title: "findSiteCapacityData",
        actionPrefix: 'findSiteCapacity',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.uniqueKey;
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorlogi/find/capacity`
        }
    },
    {
        title: "updateVendorData",
        actionPrefix: 'updateVendor',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/update/status`
        }
    },
    {
        title: "updateTrackingStatusData",
        actionPrefix: 'updateTrackingStatus',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorlogi/update/tracking/status`
        }
    },
    {
        title: "retryLRData",
        actionPrefix: 'retryLR',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorlogi/retry/create/lr`
        }
    },
    {
        title: "appotDetWhAsnDetData",
        actionPrefix: 'appotDetWhAsnDet',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/asn/detail`
        }
    },
    {
        title: "getAllOrderStatusData",
        actionPrefix: 'getAllOrderStatus',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/entpo/get/all/order/status`
        }
    },
    {
        title: "uploadVendorFilesImagesData",
        actionPrefix: 'uploadVendorFilesImages',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/custom/generic/file/upload`,
            extraHeader: {
                "Content-Type": "multipart/form-data",
            },
        }
    },
    {
        title: "updateTnaStatusData",
        actionPrefix: 'updateTnaStatus',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/entpo/create/tna/status`
        }
    },
    {
        title: "updateBillDiscountingData",
        actionPrefix: 'updateBillDiscounting',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.type;
                return payload
            },
            buildUrl: (payload) =>
                payload?.type ? `${CONFIG.SM_BACKEND_BASE_URL}/purchase/transactions/update/invoices/request/${payload?.type}`
            : `${CONFIG.SM_BACKEND_BASE_URL}/purchase/transactions/update/invoices/request`
        }
    },
    {
        title: "calculateBillDiscountingData",
        actionPrefix: 'calculateBillDiscounting',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorfinance/calculate/bill/discount`
        }
    },
    {
        title: "submitBillDiscountingData",
        actionPrefix: 'submitBillDiscounting',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorfinance/submit/finance/data`
        }
    },
    {
        title: "vendFindAllAddressData",
        actionPrefix: 'vendFindAllAddress',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorship/find/all/address`
        }
    },
    {
        title: "vendFindAllLocationData",
        actionPrefix: 'vendFindAllLocation',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorship/find/all/location`
        }
    },
    {
        title: "getAllTransportersData",
        actionPrefix: 'getAllTransporters',
        message: 'Request Completed Successfully',
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorlogi/get/all/transporters?type=${payload?.type}&pageNo=${payload?.pageNo}&search=${payload?.search}&slCode=${payload?.slCode}`
        }
    },
    {
        title: "vendorpoGetPodetailData",
        actionPrefix: 'vendorpoGetPodetail',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorpo/get/poDetail`
        }
    },
    {
        title: "vendorshipFindSrdetailData",
        actionPrefix: 'vendorshipFindSrdetail',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/auto/detail`
        }
    },
    {
        title: "vendorshipCreateSrNewData",
        actionPrefix: 'vendorshipCreateSrNew',
        message: 'Request Completed Successfully',
        requestData: {
            getExtraHeaderWithPayload: (payload) => {
                return { "X-REQUEST-ID": payload?.uuid }
            },
            updatePayload: ({ ...payload }) => {
                delete payload.uuid;
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorship/create/sr/new`,
        }
    },
    {
        title: "createMultipleAsnData",
        actionPrefix: 'createMultipleAsn',
        message: 'Request Completed Successfully',
        requestData: {
            getExtraHeaderWithPayload: (payload) => {
                return { "X-REQUEST-ID": payload?.[0]?.uuid }
            },
            updatePayload: ([...payload]) => {
                payload?.map(item => {
                    delete item?.uuid;
                })
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/create`,
        }
    },

    {
        title: "updateAutoASNLevelsData",
        actionPrefix: 'updateAutoASNLevels',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/auto/approve/asn/update/asn`
        }
    },
    {
        title: "createAutoASNLevelsData",
        actionPrefix: 'createAutoASNLevels',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/auto/approve/asn/create/asn/config`
        }
    },
    {
        title: "deleteAutoASNLevelsData",
        actionPrefix: 'deleteAutoASNLevels',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/auto/approve/asn/delete/asn`
        }
    },
    {
        title: "getAutoRefreshData",
        actionPrefix: 'getAutoRefresh',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/auto/approve/asn/retrigger`
        }
    },
    {
        title: "createAutoASNLevelsExcelData",
        actionPrefix: 'createAutoASNLevelsExcel',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/auto/approve/asn/create/asn`,
            extraHeader: {
                "Content-Type": "multipart/form-data",
            },
        }
    },
    {
        title: "addAutoASNConfigData",
        actionPrefix: 'addAutoASNConfig',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.SYSTEM_CONFIG}/add/auto/asn/config`
        }
    },
    {
        title: "poGlobalUploadExcelData",
        actionPrefix: 'poGlobalUploadExcel',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/po/global/config/upload/excel`,
            extraHeader: {
                "Content-Type": "multipart/form-data",
            },
        }
    },
    {
        title: "poGlobalConfigDeleteData",
        actionPrefix: 'poGlobalConfigDelete',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/po/global/config/delete`,
        }
    },
    {
        title: "getAllCommentsData",
        actionPrefix: 'getAllComments',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/find/comments`
        }
    },

    {
        title: "formSettingGetLrData",
        actionPrefix: 'formSettingGetLr',
        message: 'Request Completed Successfully',
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.BASE_URL}/system/config/form/setting/get/lr`
        }
    },
    {
        title: "vendorlogiLrCreateData",
        actionPrefix: 'vendorlogiLrCreate',
        message: 'Request Completed Successfully',
        requestData: {
            getExtraHeaderWithPayload: (payload) => {
                return { "X-REQUEST-ID": payload?.uuid }
            },
            updatePayload: ({ ...payload }) => {
                delete payload.uuid;
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/vendorportal/vendorlogi/lr/create`,
        }
    },
    {
        title: "vendorlogiFindLrAutoData",
        actionPrefix: 'vendorlogiFindLrAuto',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                return payload
            },
            buildUrl: (payload) => `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl}`
            // buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorlogi/find/lr/auto`
        }
    },
    {
        title: "getPoStockReportData",
        actionPrefix: 'getPoStockReport',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/get/vstockreport`,
            updatePayload: ({ ...payload }) => {
                delete payload.displayName;
                delete payload.status
                return payload
            }
        }
    },
    {
        title: "getCreateOrderHistoryData",
        actionPrefix: 'getCreateOrderHistory',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/get/vendorder/request/history`,
            updatePayload: ({ ...payload }) => {
                delete payload.displayName;
                delete payload.status;
                return payload
            }
        }
    },
    {
        title: "createPoArticleData",
        actionPrefix: 'createPoArticle',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/multiple/article/create`
        }
    },
    {
        title: "utilityDocumentDeleteData",
        actionPrefix: 'utilityDocumentDelete',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/utility/document/delete`,
        }
    },
    {
        title: "vendorlogiLrGetRateData",
        actionPrefix: 'vendorlogiLrGetRate',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorlogi/lr/get/rate`,
        }
    },
    {
        title: "updateLogisticsData",
        actionPrefix: 'updateLogistics',
        message: 'Request Completed Successfully',
        requestData: {
            getExtraHeaderWithPayload: (payload) => {
                return { "X-REQUEST-ID": payload?.uuid }
            },
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.uuid;
                return payload
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${payload?.apiUrl}`
        }
    },
    {
        title: "getShipmentAdviceAllSsData",
        actionPrefix: 'getShipmentAdviceAllSs',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorlogi/find/all/ss`,
        }
    },
    {
        title: "vendorlogiRecommendationData",
        actionPrefix: 'vendorlogiRecommendation',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/logistics/recommendation/api`,
        }
    },
    {
        title: "poGlobalConfigCreateData",
        actionPrefix: 'poGlobalConfigCreate',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiAction;
                return payload
            },
            buildUrl: (payload) => `${CONFIG.BASE_URL}/po/global/config/${payload.apiAction}`,
        }
    },
    {
        title: "getDashboardSiteFilterData",
        actionPrefix: 'getDashboardSiteFilter',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/system/config/dashboard/filter`,
        }
    },
    {
        title: "getWhDashboardData",
        actionPrefix: 'getWhDashboard',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/wh/apt/data`,
        }
    },
    {
        title: "whDashboardDetailData",
        actionPrefix: 'whDashboardDetail',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/wh/apt/data/detail`,
        }
    },
    {
        title: "getBoxAnalysisDashboardData",
        actionPrefix: 'getBoxAnalysisDashboard',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/pie/chart/graph`,
        }
    },
    {
        title: "getASNDashboardDetailsData",
        actionPrefix: 'getASNDashboardDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/vendorship/get/asn/dashboard/details`,
        }
    },
    {
        title: "getOrderTrackingDashboardUpperDetailsData",
        actionPrefix: 'getOrderTrackingDashboardUpperDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/dashboard/upr/wdw`,
        }
    },
    {
        title: "getOrderTrackingDashboardGrcDetailsData",
        actionPrefix: 'getOrderTrackingDashboardGrcDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/dashboard/upr/wdw`,
        }
    },
    {
        title: "getOrderTrackingDashboardGraphDetailsData",
        actionPrefix: 'getOrderTrackingDashboardGraphDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/dashboard/upr/wdw`,
        }
    },
    {
        title: "getOrderTrackingDashboardBottomDetailsData",
        actionPrefix: 'getOrderTrackingDashboardBottomDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/dashboard/lwr/wdw`,
        }
    },
    {
        title: "saveSiteAndItemFilterData",
        actionPrefix: 'saveSiteAndItemFilter',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/plan/settings/save/arsSiteAndArsItemFilter?filterType=${payload?.filterType}`,
        }
    },
    {
        title: "getARSDashboardDataData",
        actionPrefix: 'getARSDashboardData',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.ARS}/get/all/arsDashboard/data`,
        }
    },
    {
        title: "getDailySalesTrackerData",
        actionPrefix: 'getDailySalesTracker',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}${CONFIG.ARS}/get/daily/sales/tracker`,
            method: 'POST'
        }
    },
    {
        title: "getSiteWiseDailySalesTrackerData",
        actionPrefix: 'getSiteWiseDailySalesTracker',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}${CONFIG.ARS}/get/site/wise/daily/sales/tracker`,
            method: 'POST'
        }
    },
    {
        title: "deleteWHApptSiteDetailsData",
        actionPrefix: 'deleteWHApptSiteDetails',
        message: 'Request Completed Successfully',
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/appot/det/wh/delete/level/${payload}`
        }
    },
    {
        title: "entlogiUpdateShipmentData",
        actionPrefix: 'entlogiUpdateShipment',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/entlogi/update/shipment`,
        }
    },
    {
        title: "documentGetAllFileData",
        actionPrefix: 'documentGetAllFile',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/utility/document/get/all/file`,
        }
    },
    {
        title: "getOrderRequestColorData",
        actionPrefix: 'getOrderRequestColor',
        errorMessage: 'Failed to get the colors list.',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/get/icodecolmap`,
        }
    },
    {
        title: "createOrderRequestIndentData",
        actionPrefix: 'createOrderRequestIndent',
        message : "Order created successfully!",
        errorMessage: 'Failed to create order with this order request details!',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/multiple/article/create`,
        }
    },
    {
        title: "deleteAddressLineItemData",
        actionPrefix: 'deleteAddressLineItem',
        message : "Address deleted successfully!",
        errorMessage: 'Failed to delete the selected address!',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/address/master/delete?id=${payload.id}`,
        }
    },
    {
        title: "updateAddressData",
        actionPrefix: 'updateAddress',
        message : "Address update successfully!",
        errorMessage: 'Failed to update the address!',
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload?.apiUrl
                return payload
            },
            buildUrl: (payload) => `${CONFIG.BASE_URL}${payload.apiUrl}`,
        }
    },
    {
        title: "getAllTNAOrderHistoryData",
        actionPrefix: 'getAllTNAOrderHistory',
        message : "Order created successfully!",
        errorMessage: 'Failed to create order with this order request details!',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/entpo/get/all/tna/order/history`,
        }
    },
    {
        title: "getTRFData",
        actionPrefix: 'getTRF',
        errorMessage: 'Failed to get TRF data',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/get/trf/auto/data`,
        }
    },
    {
        title: "viewTRFData",
        actionPrefix: 'viewTRF',
        errorMessage: 'Failed to view TRF data',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/view/trf/data`,
        }
    },
    {
        title: "submitTrfData",
        actionPrefix: 'submitTrf',
        message: 'TRF Data Submitted Successfully',
        requestData: {
            method: 'POST',
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/trf/submit`
        }
    },
    {
        title: "checkAsnRestrictionData",
        actionPrefix: 'checkAsnRestriction',
        errorMessage: 'Cannot Create ASN',
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorship/check/asn/restriction`,
        }
    },
    {
        title : "getOrderRequestData",
        actionPrefix : 'getOrderRequest',
        errorMessage : 'Failed to get order request details',
        requestData : {
            buildUrl : (payload) => `${CONFIG.BASE_URL}/admin/digiproc/edit`
        }
    },
    {
        title : "getOrderTrackingProcessedOrderData",
        actionPrefix : 'getOrderTrackingProcessedOrder',
        errorMessage : 'Failed to get order request details',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/get/order/data/processed`
        }
    },
    {
        title : "getOrderTrackingDashboardHirData",
        actionPrefix : 'getOrderTrackingDashboardHir',
        errorMessage : 'Failed to get order tracking dashboard heirarchy data.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/order/tracking/level/data`
        }
    },
    {
        title : "createDiscrepencyData",
        actionPrefix : 'createDiscrepency',
        errorMessage : 'Failed to create discrepencies.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/create`
        }
    },
    {
        title : "editDiscrepencyData",
        actionPrefix : 'editDiscrepency',
        errorMessage : 'Failed to update discrepencies.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/update`
        }
    },
    {
        title : "createDebitNoteData",
        actionPrefix : 'createDebitNote',
        errorMessage : 'Failed to create Debit Note.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/create`
        }
    },
    {
        title : "deleteDiscrepencyData",
        actionPrefix : 'deleteDiscrepency',
        errorMessage : 'Failed to delete discrepencies.',
        requestData : {
            method : "DELETE",
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/delete?id=${payload.id}`
        }
    },
    {
        title : "deleteDebitNoteData",
        actionPrefix : 'deleteDebitNote',
        errorMessage : 'Failed to delete Debit Note.',
        requestData : {
            method : "DELETE",
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/delete/debit/note?id=${payload.id}`
        }
    },
    {
        title : "tagDiscrepancyToDebitNoteData",
        actionPrefix : 'tagDiscrepancyToDebitNote',
        errorMessage : 'Failed to tag the discrepancy to debit note.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/tag`
        }
    },
    {
        title : "getDiscrepancyItemDetailsData",
        actionPrefix : 'getDiscrepancyItemDetails',
        errorMessage : 'Failed to tag the discrepancy to debit note.',
        requestData : {
            method : "GET",
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/get/details?id=${payload.id}`
        }
    },
    {
        title : "purchaseDashOrderTrackPOCountData",
        actionPrefix : 'purchaseDashOrderTrackPOCount',
        errorMessage : 'Failed to get data.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/order/tracking/data`
        }
    },
    {
        title : "purchaseDashOrderTrackPOQtyAmountData",
        actionPrefix : 'purchaseDashOrderTrackPOQtyAmount',
        errorMessage : 'Failed to get data.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/order/tracking/data`
        }
    },
    {
        title: "purchaseShipmentConfirmData",
        actionPrefix: 'purchaseShipmentConfirm',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/confirm`
        }
    },
    {
        title: "purchaseShipmentCancelData",
        actionPrefix: 'purchaseShipmentCancel',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/cancel`
        }
    },
    {
        title: "purchaseShipmentAutoDetailData",
        actionPrefix: 'purchaseShipmentAutoDetail',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/auto/detail`
        }
    },
    {
        title: "getOrderAllDocumentsData",
        actionPrefix: 'getOrderAllDocuments',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/get/all/child/documents`
        }
    },
    {
        title: "poCancelChildDocumentsData",
        actionPrefix: 'poCancelChildDocuments',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/cancel/child/documents`
        }
    },
    {
        title: "findGrcItemData",
        actionPrefix: 'findGrcItem',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload : ({...payload}) => {
                delete payload.apiUrl;
                delete payload?.baseUrl;
                return payload
            },
            buildUrl: (payload) => `${payload?.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload?.apiUrl ? payload?.apiUrl :  `${CONFIG.VENDORPROTAL}/entlogi/find/grc/item`}`
        }
    },
    {
        title: "confirmGRCData",
        actionPrefix: 'confirmGRC',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload : ({...payload}) => {
                delete payload.apiUrl;
                delete payload?.baseUrl;
                return payload
            },
            buildUrl: (payload) => `${payload?.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload?.apiUrl ? payload?.apiUrl  : `${CONFIG.VENDORPROTAL}/entlogi/grc/notify`}`
        }
    },
    {
        title : "updateBoxIdData",
        actionPrefix : "updateBoxId",
        message : "Box's Details updated successfully!",
        errorMessage : "Failed to update the boxes!",
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/update/box/details/boxno`
        }
    },
    {
        title: "deleteBoxTemplateData",
        actionPrefix: 'deleteBoxTemplate',
        message: 'Request Completed Successfully',
        requestData: {
            method: "DELETE",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/delete/box/template`,
        }
    },
    {
        title: "createASNUploadExcelData",
        actionPrefix: 'createASNUploadExcel',
        message: 'Request Completed Successfully',
        requestData: {
            extraHeader: {
                "Content-Type": "multipart/form-data",
            },
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/vendorship/create/asn/upload/excel`,
        }
    },
    {
        title: "createEarlyPaymentData",
        actionPrefix: 'createEarlyPayment',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/transactions/submit/invoices/request`
        }
    },
    {
        title: "rtvRequestStatusData",
        actionPrefix: 'rtvRequestStatus',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload : ({...payload}) => {
                delete payload?.status;
                return payload
            },
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/rtv/request/status/${payload.status}`
        }
    },
    {
        title: "rtvRequestDeleteData",
        actionPrefix: 'rtvRequestDelete',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/rtv/request/delete`
        }
    },
    {
        title: "rtvRequestCreateData",
        actionPrefix: 'rtvRequestCreate',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/rtv/request/create`
        }
    },
    {
        title: "getDebitNoteData",
        actionPrefix: 'getDebitNote',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/rtv/request/get/debitnote`,
            extraHeader: { "X-Scope-Id": "purchase.rtv.view" }
        }
    },
    {
        title: "tagDebitNoteData",
        actionPrefix: 'tagDebitNote',
        message: 'Request Completed Successfully',
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/rtv/tag/debitnote`,
            extraHeader: { "X-Scope-Id": "purchase.rtv.submit" }
        }
    },
    {
        title: "getAllOrdersData",
        actionPrefix: 'getAllOrders',
        message: 'Request Completed Successfully',
        requestData: {
            updatePayload : ({...payload}) => {
                delete payload.apiUrl;
                delete payload?.baseUrl;
                delete payload?.vendorDetailsConfig;
                return payload
            },
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/get/all`
        }
    },
    {
        title: "createShipmentWithLrData",
        actionPrefix: 'createShipmentWithLr',
        message: 'Request Completed Successfully',
        requestData: {
            getExtraHeaderWithPayload: (payload) => {
                return { "X-REQUEST-ID": payload?.[0]?.uuid }
            },
            updatePayload: ([...payload]) => {
                payload?.map(item => {
                    delete item?.uuid;
                })
                return payload
            },
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/shipment/create`,
        }
    },
    {
        title: "retryLRDocData",
        actionPrefix: 'retryLRDoc',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/admin/document/retry`,
        }
    },
    {
        title: "tnaStatusTimelineData",
        actionPrefix: 'tnaStatusTimeline',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/tna/status/timeline`,
        }
    },
    {
        title : "updateDebitNoteCreditNoteData",
        actionPrefix : 'updateDebitNoteCreditNote',
        successMessage : 'Credit Note uploaded successfully.',
        errorMessage : 'Failed to upload Credit Note.',
        requestData : {
            buildUrl : (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/discrepancy/update/debit/note`
        }
    },
    {
        title: "getBusinessDashboardSummaryData",
        actionPrefix: "getBusinessDashboardSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get business dashboard summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getEarlyPaymentInvoicesData",
        actionPrefix: "getEarlyPaymentInvoices",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get early payment invoices",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/transactions/get/invoices/pending`,
            extraHeader: {
                "X-Scope-Id": "vendor.purchase.finance.view"
            }
        }
    },
    {
        title: "getPoGrcMonthlySummaryData",
        actionPrefix: "getPoGrcMonthlySummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get PO GRC monthly summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getPoGrcKpiSummaryData",
        actionPrefix: "getPoGrcKpiSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get PO GRC KPI summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getPurchaseInvoiceAgingSummaryData",
        actionPrefix: "getPurchaseInvoiceAgingSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get invoice aging summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getCustomSalesGrcVendorDashboardData",
        actionPrefix: "getCustomSalesGrcVendorDashboard",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get Custom Sales GRC dashboard data",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/custom/sales/grc/vendor/dashboard`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getSalesOverviewSummaryData",
        actionPrefix: "getSalesOverviewSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get sales overview summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getGrcReceivedSummaryData",
        actionPrefix: "getGrcReceivedSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get GRC received summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getSalesKpiSummaryData",
        actionPrefix: "getSalesKpiSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get sales KPI summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/business/summary`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getSalesTrendSummaryData",
        actionPrefix: "getSalesTrendSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get sales trend summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/custom/sales/grc/vendor/dashboard`,
            extraHeader: {
                "X-Scope-Id": "vendor.reportsanalytics.customsalesgrcreport.view"
            }
        }
    },
    {
        title: "getPaymentRequestSummaryData",
        actionPrefix: "getPaymentRequestSummary",
        message: "Request Completed Successfully",
        errorMessage: "Failed to get payment request summary",
        requestData: {
            method: "POST",
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/transactions/get/payment/request/summary`,
            extraHeader: {
                "X-Scope-Id": "purchase.finance.view"
            }
        }
    },
    {
        title: "getOrderDesignDataData",
        actionPrefix: 'getOrderDesignData',
        errorMessage: 'Failed to get design data',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/get/design/data`,
            extraHeader: { "X-Scope-Id": "vendor.purchase.orders.view" }
        }
    },
    {
        title: "getRtvRequestDetailsData",
        actionPrefix: 'getRtvRequestDetails',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/rtv/request/get/all/details`,
        }
    },
]